<template>
  <div class="container" style="width: 1280px;">
    <div class="one">
      <div class="schoolWZ" v-for="(item,index) in crumbs" :key="index+1">
        <div class="SCLeft">
          <span>{{item.title}}</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <!--  -->
            <el-breadcrumb-item class="myitem">
              <a @click="isT(-1)" :class="isTrue.length == 0? 'active' :''">不限</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item class="myitem" :key="item1.areaId" v-for="(item1,index2) in item.Cont"><a
                @click="isT(index2,item1.areaId)" :class=" item1.checked? 'active' :''">{{item1.areaName}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="schoolWZ" v-for="(itemA,index3) in crumbs1" :key="index3+3">
        <div class="SCLeft">
          <span>{{itemA.title}}</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator="">
            <el-breadcrumb-item class="myitem">
              <a @click="isT1(-1)" :class="isTrue1.length == 0? 'active' :''">不限</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item class="myitem" v-for="(itemA1,index4) in itemA.Cont" :key="index4+4"><a
                @click="isT1(index4,itemA1.name)" :class=" itemA1.checked ? 'active' :''">{{itemA1.name}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="schoolWZ" v-for="(itemB,index5) in crumbs2" :key="index5+5">
        <div class="SCLeft">
          <span>{{itemB.title}}</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator=" ">
            <el-breadcrumb-item class="myitem"><a @click="isT2(-1)" :class=" isTrue2.length ==0 ? 'active' :''">不限</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item class="myitem" v-for="(itemB1,index6) in itemB.Cont" :key="index6+6"><a
                @click="isT2(index6,itemB1.cont1)" :class=" itemB1.checked ? 'active' :''">{{itemB1.cont1}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="schoolWZ" v-for="(itemC,index7) in crumbs3" :key="index7+7" >
        <div class="SCLeft">
          <span>{{itemC.title}}</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator=" ">
            <el-breadcrumb-item class="myitem"><a @click="isT3(-1)" :class=" isTrue3.length ==0 ? 'active' :''">不限</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item class="myitem" v-for="(itemC1,index8) in itemC.Cont" :key="index8+8">
              <a style="width: 100%;text-align: center;" @click="isT3(index8,itemC1.name)"
                :class=" itemC1.checked ? 'active' :''">{{itemC1.name}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div class="schoolWZ" v-if="!showother" v-for="(itemD,index8) in crumbs4" :key="index8+8" style="border-bottom:0px">
        <div class="SCLeft">
          <span>{{itemD.title}}</span>
        </div>
        <div class="SCbottom">
          <el-breadcrumb separator=" ">
            <el-breadcrumb-item class="myitem"><a @click="isT4(-1)" :class=" isTrue4.length ==0 ? 'active' :''">不限</a>
            </el-breadcrumb-item>
            <el-breadcrumb-item class="myitem" v-for="(itemC1,index8) in itemD.Cont" :key="index8+8">
              <a style="width: 100%;text-align: center;" @click="isT4(index8,itemC1.cont1)"
                :class=" itemC1.checked ? 'active' :''">{{itemC1.cont1}}</a>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import dataInfo from '@/libs/common';
  export default {
    props: {
      showother:{
        type:Boolean,
        default:false
      }
    },
    components: {},
    data() {
      return {
        isTrue: [],
        isTrue1: [],
        isTrue2: [],
        isTrue3: [],
        isTrue4:[],
        // 面包屑渲染
        crumbs: [{
          title: '院校位置：',
          Cont: this.$utils.getlocalStorage("AREA_LIST")
        }],
        crumbs1: [{
          title: '院校类型：',
          Cont: this.$utils.getlocalStorage("COLLEGESUBJECT")
        }],
        crumbs2: [{
          title: '院校隶属：',
          Cont: [{
              cont1: '教育部',
              checked: false
            },
            {
              cont1: '工业和信息化部',
              checked: false
            },
            {
              cont1: '公安部',
              checked: false
            },
            {
              cont1: '国家民族事务委员会',
              checked: false
            },
            {
              cont1: '交通运输部',
              checked: false
            },
            {
              cont1: '中国科学院',
              checked: false
            },
            {
              cont1: '中国人民解放军',
              checked: false
            },
          ]
        }],
        crumbs3: [{
          title: '院校级别：',
          Cont: []
        }],
        crumbs4: [{
          title: '其他选项：',
          Cont: [{
            cont1: '中外合作',
            checked: false
          },{
            cont1: '校企合作',
            checked: false
          }, {
            cont1: '师范类',
            checked: false
          },{
            cont1: '3+2贯通',
            checked: false
          }]
        }],
      };
    },
    computed: {},
    methods: {
      cleardata() {
        this.isTrue = []
        this.isTrue1 = []
        this.isTrue2 = []
        this.isTrue3 = []
        this.isTrue4 = []
      },
      isT(index, areaId) {
        if (index == -1) {
          this.isTrue = []
          this.crumbs[0].Cont.forEach(item => {
            item.checked = false;
          });
        } else {
          this.crumbs[0].Cont[index].checked = !this.crumbs[0].Cont[index].checked
          if (this.crumbs[0].Cont[index].checked) {
            this.isTrue.push(areaId)
          } else {
            this.isTrue.splice(this.isTrue.indexOf(areaId), 1)
          }
        }
        this.getSearch()
      },
      isT1(index, name) {
        if (index == -1) {
          this.isTrue1 = []
          this.crumbs1[0].Cont.forEach(item => {
            item.checked = false;
          });
        } else {
          this.crumbs1[0].Cont[index].checked = !this.crumbs1[0].Cont[index].checked
          if (this.crumbs1[0].Cont[index].checked) {
            this.isTrue1.push(name)
          } else {
            this.isTrue1.splice(this.isTrue1.indexOf(name), 1)
          }
        }
        this.getSearch()
      },
      isT2(index, name) {
        if (index == -1) {
          this.isTrue2 = []
          this.crumbs2[0].Cont.forEach(item => {
            item.checked = false;
          });
        } else {
          this.crumbs2[0].Cont[index].checked = !this.crumbs2[0].Cont[index].checked
          if (this.crumbs2[0].Cont[index].checked) {
            this.isTrue2.push(name)

          } else {
            this.isTrue2.splice(this.isTrue2.indexOf(name), 1)

          }
        }
        this.getSearch()
      },
      isT3(index, name) {
        if (index == -1) {
          this.isTrue3 = []
          this.crumbs3[0].Cont.forEach(item => {
            item.checked = false;
          });
        } else {
          this.crumbs3[0].Cont[index].checked = !this.crumbs3[0].Cont[index].checked
          if (this.crumbs3[0].Cont[index].checked) {

            if(name == '双一流'){
              this.isTrue3.push('双一流A')
              this.isTrue3.push('双一流B')
              this.isTrue3.push('双一流学科')
            } else {
              this.isTrue3.push(name)
            }
          } else {
            if(name == '双一流'){
              this.isTrue3.splice(this.isTrue3.indexOf('双一流A'), 1)
              this.isTrue3.splice(this.isTrue3.indexOf('双一流B'), 1)
              this.isTrue3.splice(this.isTrue3.indexOf('双一流学科'), 1)
            } else {
              this.isTrue3.splice(this.isTrue3.indexOf(name), 1)
            }
          }
        }
        this.getSearch()
      },

      isT4(index, name) {
        if (index == -1) {
          this.isTrue4 = []
          this.crumbs4[0].Cont.forEach(item => {
            item.checked = false;
          });
        } else {
          this.crumbs4[0].Cont[index].checked = !this.crumbs4[0].Cont[index].checked
          if (this.crumbs4[0].Cont[index].checked) {
            this.isTrue4.push(name)
          } else {
            this.isTrue4.splice(this.isTrue4.indexOf(name), 1)
          }
        }
        this.getSearch()
      },
      getSearch() {
        let obj = {
          collegeAreas: this.isTrue.join(","),
          collegeSubject: this.isTrue1.join(","),
          collegeSubjection: this.isTrue2.join(","),
          collegeLevel: this.isTrue3.join(","),
          majorInfo:''
        }
        if(this.isTrue4.indexOf('公立')!=-1){
          obj.collegeNature = 1
        }
        if(this.isTrue4.indexOf('中外合作')!=-1){
          obj.majorInfo +="中外,"
        }
        if(this.isTrue4.indexOf('校企合作')!=-1){
          obj.majorInfo +="校企,"
        }
        if(this.isTrue4.indexOf('师范类')!=-1){
          obj.majorInfo +="(师范,师范类";
        }
        if(this.isTrue4.indexOf('3+2贯通')!=-1){

          obj.majorInfo +="贯通,";
        }
        if(obj.majorInfo!=""){
          obj.majorInfo = obj.majorInfo.substring(0,obj.majorInfo.length-1);
        }
        this.$emit("search", obj);
      }
    },
    mounted() {},
    created() {
      let list = []
      dataInfo.level.forEach(item => {
        list.push({
          name: item,
          checked: false
        })
      });
      this.crumbs3[0].Cont = list
    }
  };
</script>
<style scoped>
  .one {
    margin-top: 10px;
    justify-content: space-around;
    width: 100%;
    background: rgba(255, 255, 255, 0.39);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-top: 0;
    padding-bottom: 0;
    min-height: 260px;
  }

  .myitem /deep/ .el-breadcrumb__separator {
    margin: 0;
  }

  .su {
    line-height: 36px !important;
    height: 36px;

  }

  .one span {
    line-height: 28px;
    margin-right: 8px;
    color: #000;
  }


  .schoolWZ {
    width: 100%;
    height: auto;
    display: flex;
    border-bottom: 1px solid #dcdfe6;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .schoolWZ .SCLeft {
    width: 115px;
  }

  .schoolWZ .SCLeft span {
    font-size: 16px;
  }

  .schoolWZ .SCmain {
    width: 64px;
    height: 60px;
    margin-right: 15px;
    margin-top: 10px;
  }

  .schoolWZ .SCmain a {
    display: block;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
    height: 32px;
    color: #333333;
    opacity: 1;
    cursor: pointer;
    font-size: 14px;
    margin: 0 10px;
  }

  .active {
    background-color: #e63233 !important;
    color: #fff !important;
    border-radius: 16px;
    padding: 2px 11px;
    box-sizing: border-box;
  }

  .schoolWZ .SCbottom {
    width: 100%;
    text-align: left;
  }

  .schoolWZ .SCbottom a {
    text-decoration: none;
    cursor: pointer;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-family: "Microsoft YaHei", Arial, 微软雅黑, SimSun, 宋体;
    font-weight: normal;
    line-height: 20px;
    color: #333333;
    opacity: 1;

    background-color: white;
    border-radius: 16px;
    padding: 2px 11px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .schoolWZ .SCbottom a:hover {
    color: #e63233;
    border-radius: 16px;
    padding: 2px 11px;
    box-sizing: border-box;
  }

  .active:hover {
    background-color: #e63233 !important;
    color: #fff !important;
    border-radius: 16px;
    padding: 2px 11px;
    box-sizing: border-box;
  }

  /*
@media (min-width: 1400px){
.container {
    width: 1500px;
	}
}
.em{
	width: 1140px;
    height: 1px;
    margin-left: 93px;
    margin-top: 30px;
    margin-bottom: 30px;
    border-bottom: 1px #eee9e9 solid;
}
.em1{
	width: 1140px;
    height: 1px;
    margin-left: 93px;
    margin-bottom: 10px;
    border-bottom: 1px #eee9e9 solid;
}
@media (max-width: 750px){
  body {
    width: 100%;
    height: auto;
  }
  .em{width: 100%;  margin-left: 0; margin-top: 10px; margin-bottom: 10px;}
  .em1{width: 100%; margin-left: 0;}
  .schoolWZ .SCLeft{width: 134px;}
  .one{
     overflow: auto;
     margin-top: 20px;
     margin-bottom: 20px;
   }
   .one span{
       flex-shrink: 0;
   }
}
@media (max-width:980px){
  .em{width: 100%;  margin-left: 0; margin-top: 10px; margin-bottom: 10px;}
  .em1{width: 100%; margin-left: 0;}
}

@media (max-width:1400px){
  .em{width: 100%;  margin-left: 0; margin-top: 10px; margin-bottom: 10px;}
  .em1{width: 100%; margin-left: 0;}
} */
</style>



// WEBPACK FOOTER //
// src/components/vCrumbs.vue